interface SparklineProps {
  data: (number | null)[]
  color?: string
  height?: number
  width?: number
  className?: string
}

export function Sparkline({ data, color = '#3B82F6', height = 28, width = 80, className = '' }: SparklineProps) {
  const valid = data.filter((v): v is number => v !== null)
  if (valid.length < 2) {
    return <span className="text-gray-300 text-xs">—</span>
  }

  const min = Math.min(...valid)
  const max = Math.max(...valid)
  const range = max - min || 1
  const pad = 3

  const step = (data.length - 1) > 0 ? width / (data.length - 1) : width
  const pts: string[] = []

  data.forEach((val, i) => {
    if (val === null) return
    const x = i * step
    const y = (height - pad) - ((val - min) / range) * (height - pad * 2) + pad
    pts.push(`${x.toFixed(1)},${y.toFixed(1)}`)
  })

  if (pts.length < 2) return <span className="text-gray-300 text-xs">—</span>

  const pathD = `M ${pts.join(' L ')}`
  const lastPt = pts[pts.length - 1].split(',')

  return (
    <svg
      width={width}
      height={height}
      className={className}
      aria-hidden="true"
      style={{ overflow: 'visible' }}
    >
      <path d={pathD} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={parseFloat(lastPt[0])} cy={parseFloat(lastPt[1])} r="2" fill={color} />
    </svg>
  )
}
